import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import RefundPolicy from "@/pages/RefundPolicy";
import Security from "@/pages/Security";
import VerifyBundle from "@/pages/VerifyBundle";
import Faq from "@/pages/Faq";
import HrInvestigations from "@/pages/HrInvestigations";
import LegalCourtBundles from "@/pages/LegalCourtBundles";
import FamilyLawDivorce from "@/pages/FamilyLawDivorce";
import TenancyDisputes from "@/pages/TenancyDisputes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Reset scroll on every route change — unless the URL targets an anchor
// (e.g. /faq#processing), in which case the page handles its own scroll.
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/refunds" element={<RefundPolicy />} />
            <Route path="/security" element={<Security />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/hr-workplace-investigations" element={<HrInvestigations />} />
            <Route path="/legal-court-bundles" element={<LegalCourtBundles />} />
            <Route path="/whatsapp-evidence-divorce-family-court" element={<FamilyLawDivorce />} />
            <Route path="/whatsapp-evidence-tenancy-disputes" element={<TenancyDisputes />} />
            <Route path="/verify" element={<VerifyBundle />} />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
